module.exports = __webpack_public_path__ + "static/flower-blanket-farewell-to-summer-d396a34c7c76cb036035ccbfb3d8dd63.jpg";